import { Component } from '@angular/core';
import { makeProvider } from '@shared/form-fields/make-provider';
import { BaseMultiSelectFormFieldComponent } from './base-multi-select-form-field.component';

@Component({
    selector: 'app-multi-select-form-field',
    styleUrls: ['./multi-select-form-field.component.scss'],
    templateUrl: './multi-select-form-field.component.html',
    providers: [makeProvider(MultiSelectFormFieldComponent)],
})
export class MultiSelectFormFieldComponent<T> extends BaseMultiSelectFormFieldComponent<T> {
}
